/**
 * Google Tag Manager utilities
 */

// Default GTM Container ID to use when client doesn't specify one
const DEFAULT_GTM_ID = 'GTM-5QDRNWW';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Initialize Google Tag Manager by loading the script and setting up dataLayer
 */
export function initializeGTM(gtmId: string = DEFAULT_GTM_ID): void {
  if (!gtmId || document.getElementById('gtm-script')) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.id = 'gtm-script';
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);
}

/**
 * Push an event to the GTM dataLayer
 */
export function pushGTMEvent(
  event: string,
  data: Record<string, unknown> = {}
): void {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

export { DEFAULT_GTM_ID };
